import { render, staticRenderFns } from "./LeadAlerts.vue?vue&type=template&id=0b4d8d57&scoped=true&"
import script from "./LeadAlerts.vue?vue&type=script&lang=js&"
export * from "./LeadAlerts.vue?vue&type=script&lang=js&"
import style0 from "./LeadAlerts.vue?vue&type=style&index=0&id=0b4d8d57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d8d57",
  null
  
)

export default component.exports